export const AVATAR_DIMENSION = 96;
